import { DetailedHTMLProps, IframeHTMLAttributes } from 'react';

export interface IframeMediaType extends DetailedHTMLProps<IframeHTMLAttributes<HTMLIFrameElement>, HTMLIFrameElement> {
  videoHref: string;
}

export function IframeMedia({ videoHref, ...props }: IframeMediaType) {
  return <iframe src={videoHref} {...props}></iframe>;
}
